<template>
  <div data-cy="listings-no-results" class="mx-auto font-large mb-5" v-limit="500">
    <img
      :class="isMobile ? 'my-4' : 'mb-4 mt-5'"
      src="https://assets.bungalow.com/illustrations/full-color/happy-home.png"
    />
    <h3 class="header-md mb-3">
      {{ isRoomsOffering ? 'No shared homes found' : 'No entire homes found' }}
    </h3>
    <div v-limit="350" class="mx-auto">
      <template v-if="marketCategoryName">
        <p class="pb-3">
          Check out <span class="font-black underline">all available</span> {{ homeType }} in
          {{ market.displayName }} not just the ones near {{ marketCategoryName }}!
        </p>
        <b-button
          v-limit="275"
          block
          class="mx-auto mt-4"
          variant="gradient"
          @click="viewAllListings"
          data-cy="no-results-view-all-homes"
        >
          View all homes in {{ market.displayName }}
        </b-button>
      </template>
      <template v-else>
        <p class="font-small">
          Join our waitlist to be the first to know about new {{ homeType }} as they become
          available!
        </p>
        <b-button
          block
          v-limit="275"
          variant="gradient"
          class="mx-auto mt-4"
          @click="openWaitListModal"
          data-cy="no-results-join-waitlist"
        >
          Join the waitlist
        </b-button>
      </template>
      <b-btn
        block
        v-limit="275"
        variant="light"
        class="mx-auto mt-3"
        data-cy="no-results-browse-cities"
        @click="browseCitiesOnCLickHandler"
      >
        Browse Other Cities
      </b-btn>
    </div>
  </div>
</template>

<script>
import { marketSelectorLocations } from '@/constants/nav.js'
import WaitListModal from '../Modals/Listings/WaitListModal.vue'
import MarketSelectionModal from '../Modals/MarketSelect/MarketSelectionModal.vue'

export default {
  name: 'NoResults',
  props: {
    market: {
      type: Object,
      required: true,
    },
    homeType: {
      type: String,
      required: true,
    },
    marketCategoryName: {
      type: String,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isRoomsOffering() {
      return this.homeType !== 'homes'
    },
  },
  methods: {
    viewAllListings() {
      const { offering, market } = this.$route.params

      this.$router
        .replace({
          name: 'Listings',
          params: { offering, market },
        })
        .catch(() => {})
    },
    openWaitListModal() {
      this.$root.$emit('openModal', {
        modalComponent: WaitListModal,
        props: { market: this.market },
      })
    },
    browseCitiesOnCLickHandler() {
      this.isMobile
        ? this.$root.$emit('openModal', {
            modalComponent: MarketSelectionModal,
            fullscreen: true,
          })
        : this.$root.$emit('showMarketSelect', {
            location: marketSelectorLocations.HEADER,
          })
    },
  },
}
</script>
